{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Modelli",
    "DESCRIPTION": "Visualizza i modelli di messaggio sincronizzati dalle tue caselle WhatsApp. Per creare o modificare un modello, gestiscilo tramite il tuo fornitore.",
    "COUNT": "{n} modello | {n} modelli",
    "LEARN_MORE": "Scopri di più sui modelli WhatsApp",
    "SYNC_TEMPLATES": "Sincronizza modelli",
    "SYNC_SUCCESS": "Sincronizzazione dei modelli avviata per tutte le caselle WhatsApp. Gli aggiornamenti potrebbero richiedere qualche minuto.",
    "PARTIAL_SYNC_ERROR": "Sincronizzazione dei modelli avviata per alcune caselle WhatsApp, ma non è stato possibile sincronizzarne altre.",
    "SYNC_ERROR": "Impossibile avviare la sincronizzazione dei modelli. Riprova.",
    "SEARCH_PLACEHOLDER": "Cerca per contenuto o nome...",
    "MANAGE_IN_META": "Gestisci in Meta",
    "LOADING": "Caricamento modelli WhatsApp...",
    "EMPTY": "Nessun modello WhatsApp trovato.",
    "NO_RESULTS": "Nessun modello corrisponde ai filtri applicati.",
    "FETCH_ERROR": "Impossibile caricare i modelli WhatsApp. Riprova.",
    "PARTIAL_FETCH_ERROR": "Non è stato possibile caricare alcuni modelli WhatsApp. Riprova.",
    "LAST_SYNC_ATTEMPT": "Ultimo tentativo di sincronizzazione il {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Non inviato per l'approvazione WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Tutte le caselle",
      "ALL_LANGUAGES": "Tutte le lingue",
      "ALL_TYPES": "Tutti i tipi"
    },
    "TYPES": {
      "TEXT": "Testo",
      "IMAGE": "Immagine",
      "VIDEO": "Video",
      "DOCUMENT": "Documento",
      "CALL_TO_ACTION": "Invito all'azione",
      "COPY_CODE": "Copia codice"
    },
    "PREVIEW": {
      "TITLE": "Anteprima modello",
      "DESCRIPTION": "Visualizza in anteprima come appare questo modello in WhatsApp.",
      "OPEN": "Anteprima di {name}",
      "CLOSE": "Chiudi anteprima",
      "DETAILS": "Dettagli modello",
      "STATUS": "Stato",
      "TYPE": "Tipo di contenuto",
      "CATEGORY": "Categoria",
      "LANGUAGE": "Lingua",
      "INBOXES": "Caselle"
    }
  }
}
